import React, { useState } from 'react';
import i18n from 'i18next';
import { motion } from 'framer-motion';
import { registerDecoration } from 'core/forms';
import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';
import styles from '../styles/formDecorationDynamicVariablesView.module.scss';

const listOfVariables = {
  userVariables: [
    '@user_name@',
    '@first_name@',
    '@last_name@',
    '@user_code@',
    '@user_login@',
    '@user_email@',
    'user_refferal_code@',
    '@user_manager_name@',
    '@user_custom_a@',
    '...',
    '@user_custom_u@',
  ],
  activityVariables: ['@course_name@', '@course_code@'],
  enrollmentVariables: [
    '@enrollment_id@',
    '@enrollment_type@',
    '@enrollment_status@',
    '@enrollment_score@',
    '@enrollment_due_on@',
    '@enrollment_url@',
    '@enrollment_survery_url@',
    '@enrollment_assessment_url@',
    '@enrollment_expires_on@',
  ],
  eventVariables: [
    '@event_code@',
    '@start_on@',
    '@end_on@',
    '@event_name@',
    '@primary_instructor@',
    '@city@',
    '@primary_location@',
    '@details@',
    '@event_external_url@',
  ],
};

const VariableSection = ({ title, variables }) => (
  <>
    <Typo variant="s01" weight="medium">
      {title}
    </Typo>
    <ul className={styles.list}>
      {variables?.map((variable) => (
        <li key={variable} className={styles.item}>
          <Typo variant="s01">{variable}</Typo>
        </li>
      ))}
    </ul>
  </>
);

function DynamicVariables({ schema }) {
  const { title, buttonText } = schema;
  const [shouldShowText, setShouldShowText] = useState(false);

  const onHandleClick = () => setShouldShowText(!shouldShowText);

  return (
    <>
      <Button
        className={styles.button}
        variant="outlined"
        icon="arrow"
        iconPosition="left"
        text={buttonText}
        onClick={onHandleClick}
      />

      {shouldShowText && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          key="form-decoration-dynamic-variables-view"
        >
          <div className={styles.element}>
            <Typo variant="s01" className={styles.text}>
              {title}
            </Typo>

            <div className={styles.sectionsContainer}>
              <div className={styles.sectionOne}>
                <VariableSection
                  title={i18n.t('user-variables')}
                  variables={listOfVariables.userVariables}
                />
                <VariableSection
                  title={i18n.t('activity-variables')}
                  variables={listOfVariables.activityVariables}
                />
              </div>
              <div className={styles.sectionTwo}>
                <VariableSection
                  title={i18n.t('enrollment-variables')}
                  variables={listOfVariables.enrollmentVariables}
                />
                <VariableSection
                  title={i18n.t('event-variables')}
                  variables={listOfVariables.eventVariables}
                />
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
}

registerDecoration('dynamicVariables', React.memo(DynamicVariables));

export default DynamicVariables;
